<template>
  <div class="pagination pagination-centered">
    <nav class="paginator" aria-label="Paginering">
      <ul>
        <li v-if="currentPage > 1">
          <button
            :data-pagenumber="currentPage - 1"
            :aria-label="`Föregående sida. Gå till sida ${currentPage - 1}`"
            class="pagenumber previous"
            @click="$emit('page-change', currentPage - 1)"
          >Föregående sida</button>
          <button
            :data-pagenumber="currentPage - 1"
            :aria-label="`Föregående sida. Gå till sida ${currentPage - 1}`"
            class="pagenumber previous mobile"
            @click="$emit('page-change', currentPage - 1)"
          ><span class="icon-pil"><svg-icon icon-name="triangel-pil-vanster" /></span></button>
        </li>

        <li
          v-if="currentPage - 2 > 0"
          :class="currentPage === pageCount ? '' : 'mobile-free'"
        >
          <button :data-pagenumber="currentPage - 2" :aria-label="`Gå till sida ${currentPage - 2}`" class="pagenumber" @click="$emit('page-change', currentPage - 2)">{{ currentPage - 2 }}</button>
        </li>

        <li
          v-if="currentPage > 1"
          :class="currentPage === pageCount ? '' : 'mobile-free'"
        >
          <button :data-pagenumber="currentPage - 1" :aria-label="`Gå till sida ${currentPage - 1}`" class="pagenumber" @click="$emit('page-change', currentPage - 1)">{{ currentPage - 1 }}</button>
        </li>

        <li>
          <button :data-pagenumber="currentPage" :aria-label="`${currentPage} aktuell sida`" aria-current="true" class="pagenumber active">{{ currentPage }}</button>
        </li>

        <li
          v-if="currentPage < pageCount"
          :class="currentPage === 1 ? '' : 'mobile-free'"
        >
          <button :data-pagenumber="currentPage + 1" :aria-label="`Gå till sida ${currentPage + 1}`" class="pagenumber" @click="$emit('page-change', currentPage + 1)">{{ currentPage + 1 }}</button>
        </li>

        <li
          v-if="currentPage + 2 <= pageCount"
          :class="currentPage === 1 ? '' : 'mobile-free'"
        >
          <button :data-pagenumber="currentPage + 2" :aria-label="`Gå till sida ${currentPage + 2}`" class="pagenumber" @click="$emit('page-change', currentPage + 2)">{{ currentPage + 2 }}</button>
        </li>

        <li v-if="currentPage < pageCount">
          <button
            :data-pagenumber="currentPage + 1"
            :aria-label="`Nästa sida. Gå till sida ${currentPage + 1}`"
            class="pagenumber next mobile"
            @click="$emit('page-change', currentPage + 1)"
          ><span class="icon-pil"><svg-icon icon-name="triangel-pil-hoger" /></span></button>
          <button
            :data-pagenumber="currentPage + 1"
            :aria-label="`Nästa sida. Gå till sida ${currentPage + 1}`"
            class="pagenumber next"
            @click="$emit('page-change', currentPage + 1)"
          >Nästa sida</button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SvgIcon from './svgicon.vue';

export default defineComponent({
  name: 'Pagination',
  components: { SvgIcon },
  props: {
    currentPage: { type: Number, required: true },
    pageCount: { type: Number, required: true },
  },
  emits: ['page-change'],
});
</script>
